export enum ButtonSize {
  Small = 'small',
  Medium = 'medium',
  Big = 'big',
}
